<app-header></app-header>
<div class="content-container">
  <!-- <mat-progress-bar *ngIf="loading | async" [color]="'accent'" [mode]="'indeterminate'"></mat-progress-bar> -->
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- <app-usersnap></app-usersnap> -->
